import Modal from "./modal";
import VideoPlayer from "./video-player";
import Swiper from "swiper";

class Announcement {

    protected sliderWrapper;
    protected sliderItem;
    protected buttons;
    protected btnDay;
    protected currentDay;

    constructor() {
        this.sliderWrapper = $('.this-week-slider-wrapper');
        this.sliderItem = $('.this-week-slider-item');
        this.buttons = $('.this-week-days .btn');
        this.btnDay = $('.this-week-days .btn.active').data('target');
        this.currentDay = '.day-' + this.btnDay;

        if (!this.btnDay)
            return;

        this.buttons.on('click', (e) => {
            this.showDate($(e.currentTarget))
        });

        this.initSlider(this.currentDay);
    }

    showModal(url: string) {
        if (url === '')
            return;

        let video = new VideoPlayer({url:url});
        let modal = new Modal({
            id: 'modal-announcement',
            onAfterHide: (e) => {
                e.destroy();
            },
            onAfterShow: () => {
                video.initPlay();
            }
        }, video.render());

        modal.show();
    }

    showDate(btn) {
        let day = btn.data('target');
        let slider = $('.day-' + day);

        this.sliderWrapper.removeClass('active');
        this.buttons.removeClass('active');

        btn.addClass('active');
        slider.addClass('active');

        this.initSlider('.day-' + day);
    }

    initSlider(day: string) {

        /*if ($(this.currentDay + ' .slider').hasClass('slick-initialized')) {
            ($(this.currentDay + ' .slider') as any).slick('destroy');
        }*/

        // fix при переключении дней
        //this.sliderItem.off('click');
        //$(this.currentDay + ' .slider').off('breakpoint');

        new Swiper(day, {
            slidesPerView: 'auto',
            spaceBetween: 18,
            freeMode: false,
            breakpoints: {
                768: {
                    spaceBetween: 34,
                },
                992: {
                    spaceBetween: 18,
                    slidesPerView: 3
                }
            }
        });

        this.currentDay = day;
    }

}

export default Announcement;
